import _ from 'underscore';
import { Computer, SmartPhone, Tablet } from './device-type';
import { AOLSearch, BingAndYahooSearch } from './network';
import {
  AOLSearchTop,
  AOLSearchOther,
  BingAndYahooSearchTop,
  BingAndYahooSearchOther,
} from './top-vs-other';
import { ISegmentCategory } from '../../types';

export const segmentCategories: ISegmentCategory[] = [
  {
    category: 'DeviceType',
    titleKey: 'Segment_Dropdown_Device_Type',
    segments: [
      Computer,
      SmartPhone,
      Tablet,
    ],
  },
  {
    category: 'Network',
    titleKey: 'Segment_Dropdown_Network',
    segments: [
      BingAndYahooSearch,
      AOLSearch,
    ],
  },
  {
    category: 'TopVsOther',
    titleKey: 'Segment_Dropdown_Top_Other',
    segments: [
      BingAndYahooSearchTop,
      BingAndYahooSearchOther,
      AOLSearchTop,
      AOLSearchOther,
    ],
  },
];

export function getAllSegments(segCategories: ISegmentCategory[]): string[] {
  const allSegments: string[] = [];

  _.each(segCategories, (segCategory) => {
    _.each(segCategory.segments, (segment) => allSegments.push(segment.segment));
  });

  return allSegments;
}
